<template>
  <div class="service-unavailable">
    <div class="status-display">
      <div class="status-code">503</div>
      <div class="status-title">Service Unavailable</div>
    </div>

    <div class="message-container">
      <div class="main-message">
        <van-icon name="warning" size="48" color="#ee0a24" />
        <h1>该服务已暂停</h1>
      </div>

      <div class="details">
        <p><van-icon name="info" color="#ee0a24" /> 暂停原因: 系统维护中</p>
        <p><van-icon name="clock" color="#ee0a24" /> 恢复时间: 请等待后续通知</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ServiceUnavailable"
}
</script>

<style scoped lang="less">
.service-unavailable {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100vh;
  background: #f8f9fa;
  padding: 20px;

  .status-display {
    text-align: center;
    margin-bottom: 40px;

    .status-code {
      font-size: 5rem;
      font-weight: 800;
      color: #ee0a24;
      text-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
      line-height: 1;
    }

    .status-title {
      font-size: 1.5rem;
      font-weight: 600;
      color: #495057;
      margin-top: 0.5rem;
    }
  }

  .message-container {
    background: white;
    border-radius: 12px;
    padding: 30px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
    max-width: 600px;
    width: 100%;

    .main-message {
      display: flex;
      flex-direction: column;
      align-items: center;
      text-align: center;
      margin-bottom: 25px;

      h1 {
        font-size: 1.75rem;
        color: #212529;
        margin-top: 15px;
      }
    }


    .details {
      background: #f8f9fa;
      border-radius: 8px;
      padding: 20px;
      border-left: 4px solid #ee0a24;

      p {
        font-size: 1rem;
        line-height: 1.8;
        color: #495057;
        display: flex;
        align-items: center;

        .van-icon {
          margin-right: 10px;
        }
      }
    }
  }

  @media (max-width: 600px) {
    .status-display .status-code {
      font-size: 4rem;
    }

    .message-container {
      padding: 20px;

      .main-message h1 {
        font-size: 1.5rem;
      }
    }
  }
}
</style>
